import { generateBaseMutationsFor } from "@/services/store/utils/base-generators";
import { ICategoryState } from "@/services/store/category/category-types";
import { ICategory } from "@/services/data/category/category.interface";

export const mutations = generateBaseMutationsFor<ICategoryState, ICategory>(
  "categories",
);
